import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import WorkOrderTimeline from "../OwnerDashboard/Actions/WorkOrderTimeline";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Chip,
  Avatar,
  Grid,
  Divider,
  CircularProgress,
  Tabs,
  Tab,
  TextField,
  Modal,
  Dialog,
  DialogContent,
  IconButton,
  Snackbar,
  Alert,
  Stack,
  Link,
  Tooltip,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InfoIcon from "@mui/icons-material/Info";
import HomeIcon from "@mui/icons-material/Home";
import DescriptionIcon from "@mui/icons-material/Description";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useParams, useNavigate } from "react-router-dom";
import Visits from "../WorkorderVisits";
import api, { API_BASE_URL } from "../../utils/api";
import CloseIcon from "@mui/icons-material/Close";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { useDropzone } from "react-dropzone";
import * as MuiIcons from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import AddCommentIcon from "@mui/icons-material/AddComment";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import WcIcon from "@mui/icons-material/Wc";
import PhoneIcon from "@mui/icons-material/Phone";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import EmailIcon from "@mui/icons-material/Email";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import PersonIcon from "@mui/icons-material/Person";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import UploadIcon from "@mui/icons-material/Upload";
import DeleteIcon from "@mui/icons-material/Delete";


const WorkOrdersDetails = ({ id: propId, onClose } = {}) => {
  const { id: paramId } = useParams();
  const id = propId ?? paramId;
  const theme = useTheme();
  const [statuses, setStatuses] = useState([]);

  const navigate = useNavigate();
  const [workOrderDetails, setWorkOrderDetails] = useState(null);
  const [member, setMember] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [imageURL, setImageURL] = useState(null);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [commentType, setCommentType] = useState(0);
  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [commentImageUrl, setCommentImageUrl] = useState(null);
  const [openCommentImageModal, setOpenCommentImageModal] = useState(false);
  const [files, setFiles] = useState([]);
  const [loadingFiles, setLoadingFiles] = useState(false);
  const [uploadQueue, setUploadQueue] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [filePreviewImageUrl, setFilePreviewImageUrl] = useState(null);
  const [openFileImageModal, setOpenFileImageModal] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const storedUser = sessionStorage.getItem("user");
  let currentUserId = null;

  if (storedUser) {
    try {
      const parsedUser = JSON.parse(storedUser);
      currentUserId = parsedUser?.userId ?? null;
    } catch (e) {
      console.error("Failed to parse user from sessionStorage", e);
    }
  }

  const pageCardSx = {
    borderRadius: "18px",
    border: "1px solid rgba(47,99,173,0.08)",
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
    backgroundColor: "rgba(255,255,255,0.96)",
  };

  const softCardSx = {
    borderRadius: "16px",
    border: "1px solid rgba(47,99,173,0.08)",
    boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
    backgroundColor: "#fff",
  };

  const softInsetSx = {
    borderRadius: "14px",
    border: "1px solid rgba(47,99,173,0.08)",
    backgroundColor: "rgba(47,99,173,0.03)",
  };

  const sectionIconWrapSx = {
    width: 36,
    height: 36,
    minWidth: 36,
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(47,99,173,0.08)",
    flexShrink: 0,
  };

  const primaryButtonSx = {
    backgroundColor: "#2f63ad",
    color: "white",
    fontWeight: 700,
    borderRadius: "10px",
    textTransform: "none",
    px: 2.25,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#1f4f94",
      boxShadow: "none",
    },
  };

  const secondaryButtonSx = {
    borderRadius: "10px",
    textTransform: "none",
    fontWeight: 600,
    px: 2,
    borderColor: "rgba(47,99,173,0.18)",
    color: "#223142",
    "&:hover": {
      borderColor: "#2f63ad",
      color: "#2f63ad",
      backgroundColor: "rgba(47,99,173,0.04)",
    },
  };

  const textFieldSx = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "rgba(255,255,255,0.96)",
      borderRadius: "10px",
    },
  };

  const dialogPaperSx = {
    borderRadius: "18px",
    background: "rgba(255,255,255,0.98)",
    boxShadow: "0 20px 60px rgba(0,0,0,0.22)",
  };

  const infoRowSx = {
    display: "flex",
    alignItems: "flex-start",
    gap: 1,
    py: 0.75,
    minWidth: 0,
    height: "100%",
  };

  const iconWrapSx = {
    width: 34,
    height: 34,
    minWidth: 34,
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(47,99,173,0.08)",
    flexShrink: 0,
  };

  const labelSx = {
    color: "#8a94a6",
    display: "block",
    lineHeight: 1.2,
    mb: 0.25,
  };

  const valueSx = {
    color: "#223142",
    fontWeight: 600,
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    lineHeight: 1.3,
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const getLegacyCommentImageUrl = (uploadValue) => {
    if (!uploadValue) return "";
    return `${API_BASE_URL}/workorderimages/${encodeURIComponent(uploadValue)}`;
  };

  const getFormattedDate = (dateString) => {
    if (!dateString) return "N/A";
    const parsed = new Date(dateString);
    if (Number.isNaN(parsed.getTime())) return "N/A";

    return parsed.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const workOrderResp = await api.get(`/getWorkOrders/${id}`);
        const workOrderData = workOrderResp.data;

        const memberResp = await api.get(`/members/${workOrderData.property_id}`);
        const memberData = memberResp.data;

        const usersResp = await api.get(`${API_BASE_URL}/users`);
        const fetchedUsers = usersResp.data;

        const commentsResp = await api.get(`/getExternalComments/${id}`);
        const fetchedComments = commentsResp.data;

        const statusResp = await api.get(`/statuses`);
        setStatuses(statusResp.data);

        setWorkOrderDetails(workOrderData);
        setMember(memberData);
        setUsers(fetchedUsers);
        setComments(fetchedComments);

        if (workOrderData.upload_urls && workOrderData.upload_urls.trim() !== "") {
          const filename = workOrderData.upload_urls.trim();
          const sanitizedFilename = encodeURIComponent(
            filename.split(/(\\|\/)/g).pop()
          );
          const imageUrl = `${API_BASE_URL}/workorderimages/${sanitizedFilename}`;
          setImageURL(imageUrl);
        } else {
          setImageURL(null);
        }
      } catch (error) {
        console.error("Failed to fetch details:", error);
        setError("Failed to fetch details.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchDetails();
  }, [id]);

  const getStatusInfo = (statusName) => {
    return statuses.find((s) => s.statusname === statusName);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const {
    getRootProps: getCommentRootProps,
    getInputProps: getCommentInputProps,
  } = useDropzone({
    accept: { "image/*": [] },
    multiple: false,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        setSelectedFile(file);
        setFilePreview(URL.createObjectURL(file));
      }
    },
  });

  const getWorkOrderIdForFiles = useCallback(() => {
    return (
      workOrderDetails?.order_id ||
      workOrderDetails?.workorder_id ||
      workOrderDetails?.id ||
      id
    );
  }, [workOrderDetails, id]);

  const fetchFiles = useCallback(async () => {
    const idToUse = getWorkOrderIdForFiles();
    if (!idToUse) return;

    setLoadingFiles(true);
    try {
      const res = await api.get(`/workorder-files/${idToUse}`);
      setFiles(res.data || []);
    } catch (err) {
      console.error("Error loading files:", err);
      setFiles([]);
    } finally {
      setLoadingFiles(false);
    }
  }, [getWorkOrderIdForFiles]);

  useEffect(() => {
    if (workOrderDetails) {
      fetchFiles();
    }
  }, [workOrderDetails, fetchFiles]);


  const onFilesDrop = useCallback((acceptedFiles) => {
    if (!acceptedFiles?.length) return;
    setUploadQueue((prev) => [...prev, ...acceptedFiles]);
  }, []);

  const {
    getRootProps: getFilesRootProps,
    getInputProps: getFilesInputProps,
    isDragActive: isFilesDragActive,
  } = useDropzone({
    onDrop: onFilesDrop,
    multiple: true,
    accept: {
      "image/*": [],
      "application/pdf": [".pdf"],
      "application/msword": [".doc"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
        ".docx",
      ],
      "text/plain": [".txt"],
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    },
  });

  const handleRemoveQueuedFile = (index) => {
    setUploadQueue((prev) => prev.filter((_, i) => i !== index));
  };

  const handleUploadQueuedFiles = async () => {
    const idToUse = getWorkOrderIdForFiles();
    if (!uploadQueue.length || !idToUse) return;

    setUploading(true);

    try {
      const formData = new FormData();
      formData.append("workorder_id", idToUse);

      uploadQueue.forEach((file) => {
        formData.append("upload_urls", file);
      });

      try {
        await api.post("/workorder-files", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } catch (multiErr) {
        for (const file of uploadQueue) {
          const single = new FormData();
          single.append("file", file);

          await api.post(`/workorder-files/${idToUse}`, single, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        }
      }

      setUploadQueue([]);
      await fetchFiles();
      showSnackbar("Files uploaded successfully!", "success");
    } catch (err) {
      console.error("Upload failed:", err);
      showSnackbar("Failed to upload files.", "error");
    } finally {
      setUploading(false);
    }
  };

 


  const handleDeleteFile = async (file) => {
    if (!window.confirm("Are you sure you want to delete this file?")) return;
    try {
      await api.delete(`/workorder-files/${file.id}`);
      await fetchFiles();
      showSnackbar("File deleted successfully!", "success");
    } catch (err) {
      console.error("Delete failed:", err);
      showSnackbar("Failed to delete file.", "error");
    }
  };

  const renderFileCard = (file) => {
    const ext = (file.file_name || "").split(".").pop()?.toLowerCase() || "";
    const isImage =
      file.file_type?.startsWith("image/") ||
      ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(ext);
    const isPdf = file.file_type?.includes("pdf") || ext === "pdf";
    const fileUrl = `${API_BASE_URL}/workorderimages/${encodeURIComponent((file.file_url || "").split("/").pop())}`;

    return (
      <Grid item xs={12} sm={6} md={4} key={file.id || file.file_url || file.file_name}>
        <Box
          sx={{
            borderRadius: "12px",
            border: "1px solid rgba(47,99,173,0.08)",
            backgroundColor: "rgba(47,99,173,0.02)",
            p: 1.5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
            textAlign: "center",
            height: "100%",
          }}
        >
          {isImage ? (
            <Box
              component="img"
              src={fileUrl}
              alt={file.file_name}
              sx={{ width: "100%", maxHeight: 130, borderRadius: "8px", cursor: "pointer", objectFit: "cover", border: "2px solid rgba(47,99,173,0.10)" }}
              onClick={() => { setFilePreviewImageUrl(fileUrl); setOpenFileImageModal(true); }}
            />
          ) : (
            <Box sx={{ height: 80, display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
              {isPdf
                ? <MuiIcons.PictureAsPdf sx={{ fontSize: 48, color: "#e53935" }} />
                : <FolderOutlinedIcon sx={{ fontSize: 48, color: "#2f63ad" }} />}
            </Box>
          )}

          <Typography variant="caption" sx={{ wordBreak: "break-word", color: "#223142", fontWeight: 600 }}>
            {file.file_name}
          </Typography>

          {file.uploaded_at && (
            <Typography variant="caption" sx={{ color: "#6b778c" }}>
              {new Date(file.uploaded_at).toLocaleDateString()}
            </Typography>
          )}

          <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", justifyContent: "center" }}>
            {(isImage || isPdf) && (
              <Button
                size="small"
                variant="outlined"
                startIcon={<VisibilityIcon />}
                onClick={() => { setFilePreviewImageUrl(fileUrl); setOpenFileImageModal(true); }}
                sx={{ ...secondaryButtonSx, fontSize: 11 }}
              >
                Preview
              </Button>
            )}
            <Button
              size="small"
              variant="contained"
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              download
              sx={{ ...primaryButtonSx, fontSize: 11 }}
            >
              Download
            </Button>
            <Tooltip title="Delete file">
              <IconButton size="small" color="error" onClick={() => handleDeleteFile(file)}
                sx={{ border: "1px solid rgba(220,38,38,0.2)", borderRadius: "8px" }}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Grid>
    );
  };

  const handleAddComment = async () => {
    if (!newComment.trim()) {
      showSnackbar("Comment cannot be empty.", "warning");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("work_order_id", id);
      formData.append("user_id", currentUserId);
      formData.append("comment_text", newComment);
      formData.append("is_internal", 0);

      if (selectedFile) {
        formData.append("upload_urls", selectedFile);
      }

      const response = await api.post(`/addComment`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setComments((prevComments) => [
        {
          comment_id: response.data.comment_id,
          comment_text: newComment,
          sent_at: response.data.sent_at || new Date().toISOString(),
          is_internal: commentType === "internal" ? 1 : 0,
          user_name: "You",
          user_lastname: "",
          upload_urls: selectedFile ? selectedFile.name : null,
        },
        ...prevComments,
      ]);

      setNewComment("");
      setCommentType("external");
      setSelectedFile(null);
      setFilePreview(null);
      setIsCommentModalOpen(false);

      showSnackbar("Comment added successfully!", "success");
    } catch (error) {
      console.error("Failed to add comment:", error);
      showSnackbar("Failed to add comment. Please try again.", "error");
    }
  };

  const calculateDaysOpen = (createdAt) => {
    if (!createdAt) return "N/A";

    const createdDate = new Date(createdAt);
    const today = new Date();
    const diffTime = Math.abs(today - createdDate);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  const SectionTitle = ({ icon, title, subtitle, action }) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
        flexWrap: "wrap",
        mb: 1.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
        <Box sx={sectionIconWrapSx}>{icon}</Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 700, color: "#223142", lineHeight: 1.2 }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" sx={{ color: "#6b778c", mt: 0.3 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      {action}
    </Box>
  );

  const DetailCard = ({ icon, label, value, chip = null }) => (
    <Card sx={{ ...softCardSx, p: 2, height: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.25 }}>
        <Box sx={sectionIconWrapSx}>{icon}</Box>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="caption"
            sx={{ color: "#8a94a6", display: "block", mb: 0.3 }}
          >
            {label}
          </Typography>
          {chip ? (
            chip
          ) : (
            <Typography
              variant="body2"
              sx={{
                color: "#223142",
                fontWeight: 600,
                wordBreak: "break-word",
                overflowWrap: "anywhere",
              }}
            >
              {value || "N/A"}
            </Typography>
          )}
        </Box>
      </Box>
    </Card>
  );

  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: "50vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" sx={{ textAlign: "center", mt: 4 }}>
        {error}
      </Typography>
    );
  }

  const memberPhotoUrl = `${API_BASE_URL}/images/${encodeURIComponent(
    member?.PhotoGraphicFileName?.trim() || ""
  )}`;

  const address = member?.FullAddress?.trim() || "N/A";
  const mapsLink =
    address !== "N/A"
      ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
      : null;

  const phone = member?.PhoneNumber?.trim() || null;
  const altPhone = member?.AlternatePhoneNumber?.trim() || null;
  const cellPhone = member?.CellPhoneNumber?.trim() || null;
  const email = member?.EmailAddress?.trim() || null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ p: { xs: 2, md: 3 } }}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => onClose ? onClose() : navigate("/home/memberspage")}
          sx={{ ...secondaryButtonSx, mb: 3 }}
        >
          Back
        </Button>

        <Grid container spacing={3}>
          {member && (
            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                <Card sx={{ ...pageCardSx, overflow: "hidden" }}>
                  <Box
                    sx={{
                      px: 2.5,
                      pt: 2.5,
                      pb: 2,
                      borderBottom: "1px solid rgba(47,99,173,0.08)",
                      backgroundColor: "rgba(47,99,173,0.02)",
                      textAlign: "center",
                    }}
                  >
                    <Avatar
                      src={memberPhotoUrl}
                      alt={member?.FirstName}
                      sx={{
                        width: 112,
                        height: 112,
                        margin: "0 auto",
                        mb: 1.75,
                        border: "4px solid rgba(47,99,173,0.16)",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                      }}
                    />

                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: "#223142",
                        lineHeight: 1.2,
                      }}
                    >
                      {`${member?.FirstName || ""} ${member?.LastName || ""}`.trim() ||
                        "Member"}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{
                        color: "#6b778c",
                        mt: 0.5,
                      }}
                    >
                      Member Code: {member?.ClubMemberCode || "N/A"}
                    </Typography>

                    <Box sx={{ mt: 1.5 }}>
                      <Chip
                        label={member?.ClubStatusRuleCode || "Unknown"}
                        color="success"
                        size="small"
                        icon={<VerifiedUserIcon sx={{ color: "white !important" }} />}
                        sx={{
                          fontWeight: 700,
                          height: 30,
                          borderRadius: "999px",
                        }}
                      />
                    </Box>
                  </Box>

                  <Box sx={{ p: 2.5 }}>
                    <Grid container spacing={1.5}>
                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <PersonIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Member
                            </Typography>
                            <Typography variant="body2" sx={valueSx}>
                              {member?.ClubMemberCode || "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <WcIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Gender
                            </Typography>
                            <Typography variant="body2" sx={valueSx}>
                              {member?.Gender || "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <CalendarTodayIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Birth Date
                            </Typography>
                            <Typography variant="body2" sx={valueSx}>
                              {getFormattedDate(member?.BirthDate)}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <CalendarTodayIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Join Date
                            </Typography>
                            <Typography variant="body2" sx={valueSx}>
                              {getFormattedDate(member?.JoinDate)}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <PhoneIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Phone
                            </Typography>
                            {phone ? (
                              <Link
                                href={`tel:${phone}`}
                                underline="hover"
                                sx={{
                                  color: "#2f63ad",
                                  fontSize: "0.95rem",
                                  fontWeight: 600,
                                  wordBreak: "break-word",
                                }}
                              >
                                {phone}
                              </Link>
                            ) : (
                              <Typography variant="body2" sx={valueSx}>
                                N/A
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <ContactPhoneIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Alt Phone
                            </Typography>
                            {altPhone ? (
                              <Link
                                href={`tel:${altPhone}`}
                                underline="hover"
                                sx={{
                                  color: "#2f63ad",
                                  fontSize: "0.95rem",
                                  fontWeight: 600,
                                  wordBreak: "break-word",
                                }}
                              >
                                {altPhone}
                              </Link>
                            ) : (
                              <Typography variant="body2" sx={valueSx}>
                                N/A
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <SmartphoneIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Cell
                            </Typography>
                            {cellPhone ? (
                              <Link
                                href={`tel:${cellPhone}`}
                                underline="hover"
                                sx={{
                                  color: "#2f63ad",
                                  fontSize: "0.95rem",
                                  fontWeight: 600,
                                  wordBreak: "break-word",
                                }}
                              >
                                {cellPhone}
                              </Link>
                            ) : (
                              <Typography variant="body2" sx={valueSx}>
                                N/A
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <EmailIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Email
                            </Typography>
                            {email ? (
                              <Link
                                href={`mailto:${email}`}
                                underline="hover"
                                sx={{
                                  color: "#2f63ad",
                                  fontSize: "0.95rem",
                                  fontWeight: 600,
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere",
                                }}
                              >
                                {email}
                              </Link>
                            ) : (
                              <Typography variant="body2" sx={valueSx}>
                                N/A
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12}>
                        <Box sx={infoRowSx}>
                          <Box sx={iconWrapSx}>
                            <HomeIcon sx={{ color: "#2f63ad", fontSize: 18 }} />
                          </Box>
                          <Box sx={{ minWidth: 0 }}>
                            <Typography variant="caption" sx={labelSx}>
                              Address
                            </Typography>
                            {mapsLink ? (
                              <Link
                                href={mapsLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                                sx={{
                                  color: "#2f63ad",
                                  fontSize: "0.95rem",
                                  fontWeight: 600,
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere",
                                }}
                              >
                                {address}
                              </Link>
                            ) : (
                              <Typography variant="body2" sx={valueSx}>
                                N/A
                              </Typography>
                            )}
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Card>

                <Card sx={{ ...pageCardSx, overflow: "hidden" }}>
                  <Box
                    sx={{
                      px: 2.5,
                      pt: 2.25,
                      pb: 1.5,
                      borderBottom: "1px solid rgba(47,99,173,0.08)",
                      backgroundColor: "rgba(47,99,173,0.02)",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 700, color: "#223142" }}
                    >
                      Activity Timeline
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#6b778c", mt: 0.4 }}>
                      Green Sheet activity, comments, events, and notifications.
                    </Typography>
                  </Box>

                  <Box sx={{ p: 2.5 }}>
                    <Box
                      sx={{
                        borderRadius: "14px",
                        border: "1px solid rgba(47,99,173,0.08)",
                        backgroundColor: "rgba(47,99,173,0.02)",
                        p: 1.5,
                      }}
                    >
                      <WorkOrderTimeline workOrderId={workOrderDetails.order_id} />
                    </Box>
                  </Box>
                </Card>
              </Box>
            </Grid>
          )}

          <Grid item xs={12} md={8}>
            <Card sx={{ ...pageCardSx, overflow: "hidden" }}>
              <Box
                sx={{
                  px: { xs: 2, sm: 2.5, md: 3 },
                  pt: 2.5,
                  pb: 2,
                  borderBottom: "1px solid rgba(47,99,173,0.08)",
                  backgroundColor: "rgba(47,99,173,0.02)",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: { xs: "flex-start", sm: "center" },
                    flexDirection: { xs: "column", sm: "row" },
                    gap: 1.25,
                  }}
                >
                  <Box>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: "#223142" }}>
                      Green Sheet Details
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#6b778c", mt: 0.5 }}>
                      Review green sheet information, comments, and visits.
                    </Typography>
                  </Box>

                  <Chip
                    label={`Opened ${calculateDaysOpen(workOrderDetails?.created_at)} days ago`}
                    sx={{
                      borderRadius: "999px",
                      fontWeight: 700,
                      backgroundColor: "rgba(47,99,173,0.10)",
                      color: "#2f63ad",
                    }}
                  />
                </Box>

                <Typography variant="body2" sx={{ color: "#6b778c", mt: 1.5 }}>
                  Green Sheet ID: <strong>WO-{workOrderDetails?.order_id}</strong>
                </Typography>
              </Box>

              <Box sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  variant="fullWidth"
                  sx={{
                    mb: 3,
                    minHeight: 44,
                    backgroundColor: "rgba(47,99,173,0.03)",
                    borderRadius: "12px",
                    p: 0.5,
                    "& .MuiTabs-indicator": { display: "none" },
                    "& .MuiTab-root": {
                      minHeight: 40,
                      textTransform: "none",
                      fontWeight: 700,
                      borderRadius: "10px",
                      color: "#6b778c",
                    },
                    "& .Mui-selected": {
                      backgroundColor: "#fff",
                      color: "#223142 !important",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    },
                  }}
                >
                  <Tab label="Details" />
                  <Tab label="Comments" />
                  <Tab label="Visits" />
                </Tabs>

                {activeTab === 0 && (
                  <Box
                    sx={{
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                      gap: 3,
                      pt: 1.5,
                    }}
                  >
                    {imageURL && (
                      <Card sx={{ ...softCardSx, p: 2 }}>
                        <SectionTitle
                          icon={<ImageOutlinedIcon sx={{ color: "#2f63ad", fontSize: 18 }} />}
                          title="Green Sheet Image"
                          subtitle="Click the image to preview it larger."
                        />

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                          onClick={() => setOpenImageModal(true)}
                        >
                          <Box
                            component="img"
                            src={imageURL}
                            alt="Green Sheet Evidence"
                            sx={{
                              width: "100%",
                              maxWidth: 240,
                              borderRadius: "12px",
                              border: "2px solid rgba(47,99,173,0.10)",
                              boxShadow: "0 6px 12px rgba(0,0,0,0.08)",
                            }}
                          />
                        </Box>
                      </Card>
                    )}

                    <Dialog
                      open={openImageModal}
                      onClose={() => setOpenImageModal(false)}
                      maxWidth="md"
                    >
                      <DialogContent sx={{ position: "relative", textAlign: "center" }}>
                        <IconButton
                          onClick={() => setOpenImageModal(false)}
                          sx={{ position: "absolute", top: 8, right: 8 }}
                        >
                          <CloseIcon />
                        </IconButton>
                        <img
                          src={imageURL}
                          alt="Green Sheet Evidence"
                          style={{ width: "100%", maxHeight: "90vh", objectFit: "contain" }}
                        />
                      </DialogContent>
                    </Dialog>

                    <Grid container columnSpacing={2} rowSpacing={5.5} sx={{ alignItems: "stretch", }}>
                      <Grid item xs={12} sm={6}>
                        <DetailCard
                          icon={<InfoIcon sx={{ color: "#2f63ad", fontSize: 18 }} />}
                          label="Green Sheet ID"
                          value={
                            workOrderDetails?.order_id
                              ? `WO-${workOrderDetails.order_id}`
                              : "N/A"
                          }
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <DetailCard
                          icon={<HomeIcon sx={{ color: "#2f63ad", fontSize: 18 }} />}
                          label="Property ID"
                          value={workOrderDetails.property_id || "N/A"}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <DetailCard
                          icon={<DescriptionIcon sx={{ color: "#2f63ad", fontSize: 18 }} />}
                          label="Description"
                          value={workOrderDetails.description || "No Description Available"}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <DetailCard
                          icon={<ListAltIcon sx={{ color: "#2f63ad", fontSize: 18 }} />}
                          label="Details"
                          value={workOrderDetails.details || "No Description Available"}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Card sx={{ ...softCardSx, p: 2.25, minHeight: 99 }}>
                        <DetailCard
                          icon={<CalendarTodayIcon sx={{ color: "#2f63ad", fontSize: 18 }} />}
                          label="Created"
                          value={
                            workOrderDetails.created_at
                              ? new Date(workOrderDetails.created_at).toLocaleString()
                              : "N/A"
                          }
                        />
                        </Card>
                      </Grid>
                      

                      <Grid item xs={12} sm={6}>
                        <Card sx={{ ...softCardSx, p: 2.25, minHeight: 99 }}>
                          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.25 }}>
                            <Box sx={sectionIconWrapSx}>
                              {(() => {
                                const statusInfo = getStatusInfo(workOrderDetails.status);
                                const IconComponent = statusInfo?.icon && MuiIcons[statusInfo.icon];
                                const color =
                                  theme.palette[statusInfo?.color]?.main || statusInfo?.color;

                                return IconComponent ? (
                                  <IconComponent fontSize="small" sx={{ color }} />
                                ) : (
                                  <MuiIcons.InfoOutlined
                                    fontSize="small"
                                    sx={{ color: "#2f63ad" }}
                                  />
                                );
                              })()}
                            </Box>

                            <Box sx={{ minWidth: 0, flex: 1 }}>
                              <Typography
                                variant="caption"
                                sx={{ color: "#8a94a6", display: "block", mb: 0.3 }}
                              >
                                Status
                              </Typography>

                              {(() => {
                                const statusInfo = getStatusInfo(workOrderDetails.status);
                                const color =
                                  theme.palette[statusInfo?.color]?.main ||
                                  statusInfo?.color ||
                                  "#64748b";

                                return (
                                  <Chip
                                    label={statusInfo?.statusname || "Unknown"}
                                    size="small"
                                    sx={{
                                      borderRadius: "999px",
                                      backgroundColor: color,
                                      color: "#fff",
                                      fontWeight: 700,
                                    }}
                                  />
                                );
                              })()}
                            </Box>
                          </Box>
                        </Card>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Card sx={{ ...softCardSx, p: 2.25, minHeight: 99 }}>
                          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.25 }}>
                            <Box sx={sectionIconWrapSx}>
                              <ContactPhoneIcon fontSize="small" sx={{ color: "#2f63ad" }} />
                            </Box>
                            <Box sx={{ minWidth: 0, flex: 1 }}>
                              <Typography
                                variant="caption"
                                sx={{ color: "#8a94a6", display: "block", mb: 0.3 }}
                              >
                                Contact Back Requested
                              </Typography>
                              <Chip
                                label={!!workOrderDetails.contact_back_requested ? "Yes" : "No"}
                                color={!!workOrderDetails.contact_back_requested ? "warning" : "default"}
                                size="small"
                                sx={{ borderRadius: "999px", fontWeight: 700 }}
                              />
                            </Box>
                          </Box>
                        </Card>
                      </Grid>
                    </Grid>

                    <Card sx={{ ...softCardSx, p: 2.5 }}>
                      <SectionTitle
                        icon={<FolderOutlinedIcon sx={{ color: "#2f63ad", fontSize: 18 }} />}
                        title="Files"
                        subtitle="Attach and manage files for this Green Sheet."
                      />

                      <Typography variant="body2" sx={{ mb: 1.25, color: "#6b778c" }}>
                        Drag and drop multiple files below, or click to select them.
                      </Typography>

                      <Box
                        {...getFilesRootProps()}
                        sx={{
                          ...softInsetSx,
                          p: 2,
                          textAlign: "center",
                          cursor: "pointer",
                          backgroundColor: isFilesDragActive
                            ? "#e3f2fd"
                            : "rgba(47,99,173,0.02)",
                          mb: 2,
                          borderStyle: "dashed",
                          borderWidth: "2px",
                        }}
                      >
                        <input {...getFilesInputProps()} />
                        <CloudUploadIcon sx={{ fontSize: 40, color: "#1976d2", mb: 1 }} />
                        <Typography variant="body2" color="text.secondary">
                          {isFilesDragActive
                            ? "Drop files here..."
                            : "Drag & drop multiple files here, or click to select"}
                        </Typography>
                      </Box>

                      {uploadQueue.length > 0 && (
                        <Box
                          sx={{
                            ...softInsetSx,
                            p: 1,
                            maxHeight: 150,
                            overflowY: "auto",
                            mb: 2,
                          }}
                        >
                          {uploadQueue.map((file, idx) => (
                            <Box
                              key={`${file.name}-${idx}`}
                              display="flex"
                              alignItems="center"
                              justifyContent="space-between"
                              sx={{
                                borderBottom:
                                  idx !== uploadQueue.length - 1
                                    ? "1px solid rgba(47,99,173,0.08)"
                                    : "none",
                                py: 0.75,
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{
                                  maxWidth: "80%",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                title={file.name}
                              >
                                {file.name}
                              </Typography>

                              <IconButton
                                size="small"
                                color="error"
                                onClick={() => handleRemoveQueuedFile(idx)}
                              >
                               
                              </IconButton>
                            </Box>
                          ))}
                        </Box>
                      )}

                      <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
                        <Button
                          variant="contained"
                          onClick={handleUploadQueuedFiles}
                          disabled={uploading || uploadQueue.length === 0}
                          startIcon={uploading ? null : <UploadIcon />}
                          sx={primaryButtonSx}
                        >
                          {uploading ? "Uploading..." : `Upload ${uploadQueue.length || ""}`.trim()}
                        </Button>

                        {uploadQueue.length > 0 && (
                          <Button
                            variant="outlined"
                            onClick={() => setUploadQueue([])}
                            disabled={uploading}
                            sx={secondaryButtonSx}
                          >
                            Clear
                          </Button>
                        )}
                      </Box>

                      {loadingFiles ? (
                        <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                          <CircularProgress />
                        </Box>
                      ) : files.length === 0 ? (
                        <Typography variant="body2" sx={{ color: "#6b778c" }}>
                          No files attached.
                        </Typography>
                      ) : (
                        <Grid container spacing={3}>
                          {files.map(renderFileCard)}
                        </Grid>
                      )}
                    </Card>
                  </Box>
                )}

                {activeTab === 2 && (
                  <Card sx={{ ...softCardSx, overflow: "hidden" }}>
                    <Box
                      sx={{
                        px: 2.5,
                        pt: 2.25,
                        pb: 1.5,
                        borderBottom: "1px solid rgba(47,99,173,0.08)",
                        backgroundColor: "rgba(47,99,173,0.02)",
                      }}
                    >
                      <Typography variant="h6" sx={{ fontWeight: 700, color: "#223142" }}>
                        Visits
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#6b778c", mt: 0.4 }}>
                        Scheduled and completed visits for this Green Sheet.
                      </Typography>
                    </Box>

                    <Box sx={{ p: 2.5 }}>
                      <Visits work_order_id={id} currentUserId={currentUserId} />
                    </Box>
                  </Card>
                )}

                {activeTab === 1 && (
                  <Box>
                    <Card sx={{ ...pageCardSx, overflow: "hidden" }}>
                      <Box
                        sx={{
                          px: { xs: 1.5, sm: 2, md: 3 },
                          pt: 2.25,
                          pb: 1.5,
                          borderBottom: "1px solid rgba(47,99,173,0.08)",
                          backgroundColor: "rgba(47,99,173,0.02)",
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                          <ChatBubbleOutlineIcon sx={{ color: "#2f63ad" }} />
                          <Typography variant="h6" sx={{ fontWeight: 700, color: "#223142" }}>
                            Comments
                          </Typography>
                        </Box>

                        <Typography variant="body2" sx={{ color: "#6b778c" }}>
                          Review comment history and attachments.
                        </Typography>
                      </Box>

                      <Box sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            mb: 2.5,
                          }}
                        >
                          <Button
                            variant="contained"
                            startIcon={<AddCommentIcon />}
                            onClick={() => setIsCommentModalOpen(true)}
                            sx={primaryButtonSx}
                          >
                            Add Comment
                          </Button>
                        </Box>

                        {comments.length > 0 ? (
                          <Stack spacing={2}>
                            {comments.map((comment) => {
                              const imageSrc = comment.upload_urls
                                ? getLegacyCommentImageUrl(comment.upload_urls)
                                : null;
                              const commentFiles = files.filter(f => String(f.comment_id) === String(comment.comment_id));

                              return (
                                <Card
                                  key={comment.comment_id}
                                  sx={{
                                    borderRadius: "16px",
                                    border: "1px solid rgba(47,99,173,0.08)",
                                    boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
                                    backgroundColor: "#fff",
                                    overflow: "hidden",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      px: 2,
                                      py: 1.5,
                                      borderBottom: "1px solid rgba(47,99,173,0.08)",
                                      backgroundColor: "rgba(47,99,173,0.05)",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      gap: 1.5,
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    <Chip
                                      label="External Comment"
                                      size="small"
                                      sx={{
                                        fontWeight: 700,
                                        borderRadius: "999px",
                                        color: "#1d4ed8",
                                        backgroundColor: "rgba(59,130,246,0.12)",
                                      }}
                                    />
                                  </Box>

                                  <Box sx={{ p: 2 }}>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        color: "#223142",
                                        whiteSpace: "pre-wrap",
                                        mb: imageSrc ? 1.25 : 0,
                                      }}
                                    >
                                      {comment.comment_text}
                                    </Typography>

                                    {imageSrc && (
                                      <Box sx={{ mt: 1.25 }}>
                                        <Typography
                                          variant="body2"
                                          sx={{ fontWeight: 700, color: "#223142", mb: 1 }}
                                        >
                                          Attachment
                                        </Typography>

                                        <Card
                                          sx={{
                                            ...softInsetSx,
                                            p: 2,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            gap: 1,
                                            textAlign: "center",
                                            maxWidth: 260,
                                            backgroundColor: "#fff",
                                          }}
                                        >
                                          <Box
                                            component="img"
                                            src={imageSrc}
                                            alt="Comment Attachment"
                                            sx={{
                                              maxWidth: "100%",
                                              maxHeight: 120,
                                              borderRadius: "8px",
                                              cursor: "pointer",
                                              objectFit: "cover",
                                            }}
                                            onClick={() => {
                                              setCommentImageUrl(imageSrc);
                                              setOpenCommentImageModal(true);
                                            }}
                                          />

                                          <Typography
                                            variant="body2"
                                            sx={{ mt: 0.5, wordBreak: "break-word" }}
                                          >
                                            Attachment Preview
                                          </Typography>

                                          <Box
                                            sx={{
                                              mt: 1,
                                              display: "flex",
                                              gap: 1,
                                              flexWrap: "wrap",
                                            }}
                                          >
                                            <Button
                                              size="small"
                                              variant="outlined"
                                              startIcon={<VisibilityIcon />}
                                              onClick={() => {
                                                setCommentImageUrl(imageSrc);
                                                setOpenCommentImageModal(true);
                                              }}
                                              sx={secondaryButtonSx}
                                            >
                                              Preview
                                            </Button>
                                          </Box>
                                        </Card>
                                      </Box>
                                    )}

                                    {commentFiles.length > 0 && (
                                      <Box sx={{ mt: 1.25 }}>
                                        <Typography variant="body2" sx={{ fontWeight: 700, color: "#223142", mb: 1 }}>
                                          Attached Files
                                        </Typography>
                                        <Grid container spacing={1.5}>
                                          {commentFiles.map((file) => {
                                            const ext = (file.file_name || "").split(".").pop()?.toLowerCase() || "";
                                            const isImage = file.file_type?.startsWith("image/") || ["jpg","jpeg","png","gif","bmp","webp"].includes(ext);
                                            const isPdf = file.file_type?.includes("pdf") || ext === "pdf";
                                            const fileUrl = `${API_BASE_URL}/workordercommentimages/${encodeURIComponent((file.file_url || "").split("/").pop())}`;
                                            return (
                                              <Grid item xs={12} sm={6} key={file.id}>
                                                <Box sx={{ borderRadius: "10px", border: "1px solid rgba(47,99,173,0.08)", backgroundColor: "rgba(47,99,173,0.02)", p: 1.25, display: "flex", flexDirection: "column", alignItems: "center", gap: 0.75, textAlign: "center" }}>
                                                  {isImage ? (
                                                    <Box component="img" src={fileUrl} alt={file.file_name}
                                                      onClick={() => { setFilePreviewImageUrl(fileUrl); setOpenFileImageModal(true); }}
                                                      sx={{ width: "100%", maxHeight: 110, objectFit: "cover", borderRadius: "8px", cursor: "pointer" }} />
                                                  ) : isPdf ? (
                                                    <DescriptionIcon sx={{ fontSize: 40, color: "#e53935" }} />
                                                  ) : (
                                                    <ListAltIcon sx={{ fontSize: 40, color: "#2f63ad" }} />
                                                  )}
                                                  <Typography variant="caption" sx={{ wordBreak: "break-word", color: "#223142", fontWeight: 600 }}>
                                                    {file.file_name}
                                                  </Typography>
                                                  <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap", justifyContent: "center" }}>
                                                    {(isImage || isPdf) && (
                                                      <Button size="small" variant="outlined" startIcon={<VisibilityIcon />}
                                                        onClick={() => { setFilePreviewImageUrl(fileUrl); setOpenFileImageModal(true); }}
                                                        sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 700, fontSize: 11 }}>
                                                        Preview
                                                      </Button>
                                                    )}
                                                    <Button size="small" variant="contained" href={fileUrl} target="_blank" rel="noopener noreferrer" download
                                                      sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 700, fontSize: 11, backgroundColor: "#2f63ad", boxShadow: "none", "&:hover": { backgroundColor: "#1f4f94" } }}>
                                                      Download
                                                    </Button>
                                                  </Box>
                                                </Box>
                                              </Grid>
                                            );
                                          })}
                                        </Grid>
                                      </Box>
                                    )}

                                    <Divider
                                      sx={{ my: 1.5, borderColor: "rgba(47,99,173,0.08)" }}
                                    />

                                    <Typography
                                      variant="caption"
                                      sx={{
                                        color: "#6b778c",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 0.5,
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <AccessTimeIcon sx={{ fontSize: 14 }} />
                                      Added by {comment.user_name} {comment.user_lastname || ""} on{" "}
                                      {new Date(comment.sent_at).toLocaleString()}
                                    </Typography>
                                  </Box>
                                </Card>
                              );
                            })}
                          </Stack>
                        ) : (
                          <Card sx={{ ...pageCardSx, p: 3, textAlign: "center" }}>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 600, color: "#223142" }}
                            >
                              No comments available
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ color: "#6b778c", mt: 0.75 }}
                            >
                              Add the first comment for this Green Sheet.
                            </Typography>

                            <Box sx={{ mt: 2 }}>
                              <Button
                                variant="contained"
                                startIcon={<AddCommentIcon />}
                                onClick={() => setIsCommentModalOpen(true)}
                                sx={primaryButtonSx}
                              >
                                Add Comment
                              </Button>
                            </Box>
                          </Card>
                        )}
                      </Box>
                    </Card>
                  </Box>
                )}
              </Box>
            </Card>
          </Grid>
        </Grid>

        <Modal open={isCommentModalOpen} onClose={() => setIsCommentModalOpen(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "92%", sm: 520 },
              maxHeight: "90vh",
              overflowY: "auto",
              backgroundColor: "rgba(255,255,255,0.98)",
              padding: 0,
              borderRadius: "18px",
              boxShadow: "0 20px 60px rgba(0,0,0,0.22)",
              border: "1px solid rgba(47,99,173,0.08)",
            }}
          >
            <Box
              sx={{
                px: 3,
                pt: 2.5,
                pb: 1.5,
                borderBottom: "1px solid rgba(47,99,173,0.08)",
                backgroundColor: "rgba(47,99,173,0.02)",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 700, color: "#223142" }}>
                Add Comment
              </Typography>
              <Typography variant="body2" sx={{ color: "#6b778c", mt: 0.5 }}>
                Add a comment and optionally attach an image.
              </Typography>
            </Box>

            <Box sx={{ p: 3 }}>
              <TextField
                fullWidth
                label="Comment"
                multiline
                rows={3}
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                sx={{ ...textFieldSx, mb: 2 }}
              />

              <Box sx={{ mb: 2 }}>
                <Typography
                  variant="body2"
                  sx={{ mb: 1, fontWeight: 600, color: "#223142" }}
                >
                  Attach Image
                </Typography>

                <Box
                  {...getCommentRootProps()}
                  sx={{
                    ...softInsetSx,
                    p: 2.5,
                    textAlign: "center",
                    cursor: "pointer",
                    borderStyle: "dashed",
                    borderWidth: "2px",
                  }}
                >
                  <input {...getCommentInputProps()} />
                  <CloudUploadIcon sx={{ fontSize: 40, color: "#1976d2", mb: 1 }} />
                  <Typography variant="body2" sx={{ color: "#6b778c" }}>
                    Drag & drop an image, or click to select
                  </Typography>
                </Box>
              </Box>

              {filePreview && (
                <Box sx={{ textAlign: "center", mb: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1, color: "#223142" }}>
                    Preview
                  </Typography>
                  <img
                    src={filePreview}
                    alt="Preview"
                    style={{ maxWidth: "100%", maxHeight: 150, borderRadius: 8 }}
                  />
                </Box>
              )}

              <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.25 }}>
                <Button
                  variant="outlined"
                  onClick={() => setIsCommentModalOpen(false)}
                  sx={secondaryButtonSx}
                >
                  Cancel
                </Button>

                <Button variant="contained" onClick={handleAddComment} sx={primaryButtonSx}>
                  Save Comment
                </Button>
              </Box>
            </Box>
          </Box>
        </Modal>

        <Dialog
          open={openCommentImageModal}
          onClose={() => setOpenCommentImageModal(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{ sx: dialogPaperSx }}
        >
          <DialogContent
            sx={{
              position: "relative",
              backgroundColor: "#111",
              p: 2,
              textAlign: "center",
            }}
          >
            <IconButton
              onClick={() => setOpenCommentImageModal(false)}
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                zIndex: 1,
                bgcolor: "rgba(0,0,0,0.45)",
                "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>

            <Box
              component="img"
              src={commentImageUrl}
              alt="Comment Preview"
              sx={{
                maxWidth: "100%",
                maxHeight: "85vh",
                objectFit: "contain",
                borderRadius: "10px",
              }}
            />
          </DialogContent>
        </Dialog>

        <Dialog
          open={openFileImageModal}
          onClose={() => setOpenFileImageModal(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{ sx: dialogPaperSx }}
        >
          <DialogContent
            sx={{
              position: "relative",
              backgroundColor: "#111",
              p: 2,
              textAlign: "center",
            }}
          >
            <IconButton
              onClick={() => setOpenFileImageModal(false)}
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                zIndex: 1,
                bgcolor: "rgba(0,0,0,0.45)",
                "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>

            <Box
              component="img"
              src={filePreviewImageUrl}
              alt="File Preview"
              sx={{
                maxWidth: "100%",
                maxHeight: "85vh",
                objectFit: "contain",
                borderRadius: "10px",
              }}
            />
          </DialogContent>
        </Dialog>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            severity={snackbar.severity}
            variant="filled"
            sx={{ borderRadius: 3 }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </LocalizationProvider>
  );
};

export default WorkOrdersDetails;